//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { OktaAuth,  IDToken,  TokenManagerInterface } from '@okta/okta-auth-js'
import { oktaAuthConfig } from '../../utils/okta';import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthorizedApiBase {
  /**
   * authorization token value
   */
  // public token: string

  constructor() {
    // this.token = null
  }
    protected async transformOptions(options: AxiosRequestConfig): Promise<AxiosRequestConfig> {
        options.transformResponse = (data: any) => data; // pour éviter JSON.parse
        const token = await getToken()
    options.headers!.Authorization = `Bearer ${token}` 
        return options;
      }
}

export class MyAdFactoryClass extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getallboosts(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Boost/getallboosts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetallboosts(_response);
        });
    }

    protected processGetallboosts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordboost(body: BoostBo | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Boost/recordboost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordboost(_response);
        });
    }

    protected processRecordboost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getnewbuildcontrat(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Boost/getnewbuildcontrat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetnewbuildcontrat(_response);
        });
    }

    protected processGetnewbuildcontrat(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getNewBuildUpcomingContrat(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Boost/getNewBuildUpcomingContrat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewBuildUpcomingContrat(_response);
        });
    }

    protected processGetNewBuildUpcomingContrat(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    lot(annonceId: number, signal?: AbortSignal | undefined): Promise<Classified[]> {
        let url_ = this.baseUrl + "/api/Classified/lot/{annonceId}";
        if (annonceId === undefined || annonceId === null)
            throw new Error("The parameter 'annonceId' must be defined.");
        url_ = url_.replace("{annonceId}", encodeURIComponent("" + annonceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLot(_response);
        });
    }

    protected processLot(response: AxiosResponse): Promise<Classified[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Classified[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Classified[]>(null as any);
    }

    /**
     * @param annonceIds (optional) 
     * @return Success
     */
    lots(annonceIds: number[] | undefined, signal?: AbortSignal | undefined): Promise<Classified[]> {
        let url_ = this.baseUrl + "/api/Classified/lots?";
        if (annonceIds === null)
            throw new Error("The parameter 'annonceIds' cannot be null.");
        else if (annonceIds !== undefined)
            annonceIds && annonceIds.forEach(item => { url_ += "annonceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLots(_response);
        });
    }

    protected processLots(response: AxiosResponse): Promise<Classified[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Classified[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Classified[]>(null as any);
    }

    /**
     * @return Success
     */
    program(annonceId: string, signal?: AbortSignal | undefined): Promise<Classified[]> {
        let url_ = this.baseUrl + "/api/Classified/program/{annonceId}";
        if (annonceId === undefined || annonceId === null)
            throw new Error("The parameter 'annonceId' must be defined.");
        url_ = url_.replace("{annonceId}", encodeURIComponent("" + annonceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProgram(_response);
        });
    }

    protected processProgram(response: AxiosResponse): Promise<Classified[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Classified[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Classified[]>(null as any);
    }

    /**
     * @param annonceId (optional) 
     * @return Success
     */
    programs(annonceId: string[] | undefined, signal?: AbortSignal | undefined): Promise<Classified[]> {
        let url_ = this.baseUrl + "/api/Classified/programs?";
        if (annonceId === null)
            throw new Error("The parameter 'annonceId' cannot be null.");
        else if (annonceId !== undefined)
            annonceId && annonceId.forEach(item => { url_ += "annonceId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrograms(_response);
        });
    }

    protected processPrograms(response: AxiosResponse): Promise<Classified[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Classified[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Classified[]>(null as any);
    }

    /**
     * @return Success
     */
    contract(rcClient: string, signal?: AbortSignal | undefined): Promise<Contract[]> {
        let url_ = this.baseUrl + "/api/Classified/contract/{rcClient}";
        if (rcClient === undefined || rcClient === null)
            throw new Error("The parameter 'rcClient' must be defined.");
        url_ = url_.replace("{rcClient}", encodeURIComponent("" + rcClient));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContract(_response);
        });
    }

    protected processContract(response: AxiosResponse): Promise<Contract[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Contract[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Contract[]>(null as any);
    }

    /**
     * @param rcClient (optional) 
     * @return Success
     */
    contracts(rcClient: string[] | undefined, signal?: AbortSignal | undefined): Promise<Contract[]> {
        let url_ = this.baseUrl + "/api/Classified/contracts?";
        if (rcClient === null)
            throw new Error("The parameter 'rcClient' cannot be null.");
        else if (rcClient !== undefined)
            rcClient && rcClient.forEach(item => { url_ += "rcClient=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContracts(_response);
        });
    }

    protected processContracts(response: AxiosResponse): Promise<Contract[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Contract[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Contract[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordClient(body: ClientBo | undefined, signal?: AbortSignal | undefined): Promise<ClientBo> {
        let url_ = this.baseUrl + "/api/Clients/RecordClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordClient(_response);
        });
    }

    protected processRecordClient(response: AxiosResponse): Promise<ClientBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ClientBo>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientBo>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    clientsAll(clientId: string | undefined, signal?: AbortSignal | undefined): Promise<ClientBo[]> {
        let url_ = this.baseUrl + "/api/Clients?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClientsAll(_response);
        });
    }

    protected processClientsAll(response: AxiosResponse): Promise<ClientBo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientBo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientBo[]>(null as any);
    }

    /**
     * @param projectType (optional) 
     * @param broadcastMedium (optional) 
     * @param postalCode (optional) 
     * @param productId (optional) 
     * @return Success
     */
    clients(clientId: string, projectType: string[] | undefined, broadcastMedium: string[] | undefined, postalCode: string[] | undefined, productId: string | undefined, signal?: AbortSignal | undefined): Promise<ClientBo> {
        let url_ = this.baseUrl + "/api/Clients/{clientId}?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (projectType === null)
            throw new Error("The parameter 'projectType' cannot be null.");
        else if (projectType !== undefined)
            projectType && projectType.forEach(item => { url_ += "projectType=" + encodeURIComponent("" + item) + "&"; });
        if (broadcastMedium === null)
            throw new Error("The parameter 'broadcastMedium' cannot be null.");
        else if (broadcastMedium !== undefined)
            broadcastMedium && broadcastMedium.forEach(item => { url_ += "broadcastMedium=" + encodeURIComponent("" + item) + "&"; });
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            postalCode && postalCode.forEach(item => { url_ += "postalCode=" + encodeURIComponent("" + item) + "&"; });
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClients(_response);
        });
    }

    protected processClients(response: AxiosResponse): Promise<ClientBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientBo>(null as any);
    }

    /**
     * @return Success
     */
    catchmentZone(clientId: string, signal?: AbortSignal | undefined): Promise<PlaceBo[]> {
        let url_ = this.baseUrl + "/api/Clients/catchmentZone/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCatchmentZone(_response);
        });
    }

    protected processCatchmentZone(response: AxiosResponse): Promise<PlaceBo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PlaceBo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlaceBo[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSome(body: CountFilters | undefined, signal?: AbortSignal | undefined): Promise<CountBo[]> {
        let url_ = this.baseUrl + "/api/Counts/GetSome";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSome(_response);
        });
    }

    protected processGetSome(response: AxiosResponse): Promise<CountBo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo[]>(null as any);
    }

    /**
     * @return Success
     */
    guid(id: string, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Counts/guid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGuid(_response);
        });
    }

    protected processGuid(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    countsPATCH(id: number, body: CountBo | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Counts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountsPATCH(_response);
        });
    }

    protected processCountsPATCH(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @return Success
     */
    countsDELETE(id: number, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Counts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountsDELETE(_response);
        });
    }

    protected processCountsDELETE(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    mafId(id: number | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Counts/mafId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMafId(_response);
        });
    }

    protected processMafId(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param page (optional) 
     * @param itemsPerPage (optional) 
     * @param clientId (optional) 
     * @param productName (optional) 
     * @param market (optional) 
     * @param clientName (optional) 
     * @param status (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param searchCount (optional) 
     * @return Success
     */
    getMyCounts(page: number | undefined, itemsPerPage: number | undefined, clientId: string | undefined, productName: MAFProduct | undefined, market: Market | undefined, clientName: string | undefined, status: string | undefined, order: string | undefined, orderDirection: string | undefined, searchCount: string | undefined, signal?: AbortSignal | undefined): Promise<CountBoPaginated> {
        let url_ = this.baseUrl + "/api/Counts/GetMyCounts?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (itemsPerPage === null)
            throw new Error("The parameter 'itemsPerPage' cannot be null.");
        else if (itemsPerPage !== undefined)
            url_ += "itemsPerPage=" + encodeURIComponent("" + itemsPerPage) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (productName === null)
            throw new Error("The parameter 'productName' cannot be null.");
        else if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&";
        if (market === null)
            throw new Error("The parameter 'market' cannot be null.");
        else if (market !== undefined)
            url_ += "market=" + encodeURIComponent("" + market) + "&";
        if (clientName === null)
            throw new Error("The parameter 'clientName' cannot be null.");
        else if (clientName !== undefined)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (searchCount === null)
            throw new Error("The parameter 'searchCount' cannot be null.");
        else if (searchCount !== undefined)
            url_ += "searchCount=" + encodeURIComponent("" + searchCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyCounts(_response);
        });
    }

    protected processGetMyCounts(response: AxiosResponse): Promise<CountBoPaginated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBoPaginated>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBoPaginated>(null as any);
    }

    /**
     * @param page (optional) 
     * @param itemsPerPage (optional) 
     * @param clientId (optional) 
     * @param productName (optional) 
     * @param market (optional) 
     * @param clientName (optional) 
     * @param status (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param searchCount (optional) 
     * @return Success
     */
    getAllCounts(page: number | undefined, itemsPerPage: number | undefined, clientId: string | undefined, productName: MAFProduct | undefined, market: Market | undefined, clientName: string | undefined, status: string | undefined, order: string | undefined, orderDirection: string | undefined, searchCount: string | undefined, signal?: AbortSignal | undefined): Promise<CountBoPaginated> {
        let url_ = this.baseUrl + "/api/Counts/GetAllCounts?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (itemsPerPage === null)
            throw new Error("The parameter 'itemsPerPage' cannot be null.");
        else if (itemsPerPage !== undefined)
            url_ += "itemsPerPage=" + encodeURIComponent("" + itemsPerPage) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (productName === null)
            throw new Error("The parameter 'productName' cannot be null.");
        else if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&";
        if (market === null)
            throw new Error("The parameter 'market' cannot be null.");
        else if (market !== undefined)
            url_ += "market=" + encodeURIComponent("" + market) + "&";
        if (clientName === null)
            throw new Error("The parameter 'clientName' cannot be null.");
        else if (clientName !== undefined)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (searchCount === null)
            throw new Error("The parameter 'searchCount' cannot be null.");
        else if (searchCount !== undefined)
            url_ += "searchCount=" + encodeURIComponent("" + searchCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCounts(_response);
        });
    }

    protected processGetAllCounts(response: AxiosResponse): Promise<CountBoPaginated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBoPaginated>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBoPaginated>(null as any);
    }

    /**
     * @param searchCount (optional) 
     * @return Success
     */
    search(searchCount: string | undefined, signal?: AbortSignal | undefined): Promise<CountBo[]> {
        let url_ = this.baseUrl + "/api/Counts/Search?";
        if (searchCount === null)
            throw new Error("The parameter 'searchCount' cannot be null.");
        else if (searchCount !== undefined)
            url_ += "searchCount=" + encodeURIComponent("" + searchCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<CountBo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo[]>(null as any);
    }

    /**
     * @param exportFilter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getExport(exportFilter: ExportFilter | undefined, startDate: Date | undefined, endDate: Date | undefined, signal?: AbortSignal | undefined): Promise<ExportCounts> {
        let url_ = this.baseUrl + "/api/Counts/GetExport?";
        if (exportFilter === null)
            throw new Error("The parameter 'exportFilter' cannot be null.");
        else if (exportFilter !== undefined)
            url_ += "exportFilter=" + encodeURIComponent("" + exportFilter) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExport(_response);
        });
    }

    protected processGetExport(response: AxiosResponse): Promise<ExportCounts> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExportCounts>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportCounts>(null as any);
    }

    /**
     * @param exportFilter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getExportV2(exportFilter: ExportFilter | undefined, startDate: Date | undefined, endDate: Date | undefined, signal?: AbortSignal | undefined): Promise<ExportCounts[]> {
        let url_ = this.baseUrl + "/api/Counts/GetExportV2?";
        if (exportFilter === null)
            throw new Error("The parameter 'exportFilter' cannot be null.");
        else if (exportFilter !== undefined)
            url_ += "exportFilter=" + encodeURIComponent("" + exportFilter) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportV2(_response);
        });
    }

    protected processGetExportV2(response: AxiosResponse): Promise<ExportCounts[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExportCounts[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportCounts[]>(null as any);
    }

    /**
     * @param market (optional) 
     * @return Success
     */
    getSelectableValues(market: string | undefined, signal?: AbortSignal | undefined): Promise<MasterDisplayNeufSelectableValues> {
        let url_ = this.baseUrl + "/api/Display/GetSelectableValues?";
        if (market === null)
            throw new Error("The parameter 'market' cannot be null.");
        else if (market !== undefined)
            url_ += "market=" + encodeURIComponent("" + market) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectableValues(_response);
        });
    }

    protected processGetSelectableValues(response: AxiosResponse): Promise<MasterDisplayNeufSelectableValues> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MasterDisplayNeufSelectableValues>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDisplayNeufSelectableValues>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processCount(body: DisplayReq | undefined, signal?: AbortSignal | undefined): Promise<DisplayResp> {
        let url_ = this.baseUrl + "/api/Display/ProcessCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessCount(_response);
        });
    }

    protected processProcessCount(response: AxiosResponse): Promise<DisplayResp> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DisplayResp>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisplayResp>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordCount(body: DisplayResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Display/RecordCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordCount(_response);
        });
    }

    protected processRecordCount(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    display(mafId: number, body: DisplayResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Display/{mafId}";
        if (mafId === undefined || mafId === null)
            throw new Error("The parameter 'mafId' must be defined.");
        url_ = url_.replace("{mafId}", encodeURIComponent("" + mafId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisplay(_response);
        });
    }

    protected processDisplay(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processCount2(body: DisplayReq | undefined, signal?: AbortSignal | undefined): Promise<PerformanceDisplayResp> {
        let url_ = this.baseUrl + "/api/DisplayPerformance/ProcessCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessCount2(_response);
        });
    }

    protected processProcessCount2(response: AxiosResponse): Promise<PerformanceDisplayResp> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PerformanceDisplayResp>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PerformanceDisplayResp>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordCount2(body: PerformanceDisplayResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/DisplayPerformance/RecordCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordCount2(_response);
        });
    }

    protected processRecordCount2(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    displayPerformance(mafId: number, body: PerformanceDisplayResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/DisplayPerformance/{mafId}";
        if (mafId === undefined || mafId === null)
            throw new Error("The parameter 'mafId' must be defined.");
        url_ = url_.replace("{mafId}", encodeURIComponent("" + mafId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisplayPerformance(_response);
        });
    }

    protected processDisplayPerformance(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param market (optional) 
     * @return Success
     */
    getSelectableValues2(market: string | undefined, signal?: AbortSignal | undefined): Promise<EmaillingSelectableValues> {
        let url_ = this.baseUrl + "/api/Emailing/GetSelectableValues?";
        if (market === null)
            throw new Error("The parameter 'market' cannot be null.");
        else if (market !== undefined)
            url_ += "market=" + encodeURIComponent("" + market) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectableValues2(_response);
        });
    }

    protected processGetSelectableValues2(response: AxiosResponse): Promise<EmaillingSelectableValues> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmaillingSelectableValues>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmaillingSelectableValues>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processCount3(body: EmailingReq | undefined, signal?: AbortSignal | undefined): Promise<EmailingResp> {
        let url_ = this.baseUrl + "/api/Emailing/ProcessCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessCount3(_response);
        });
    }

    protected processProcessCount3(response: AxiosResponse): Promise<EmailingResp> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmailingResp>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailingResp>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordCount3(body: EmailingResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Emailing/RecordCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordCount3(_response);
        });
    }

    protected processRecordCount3(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailing(mafId: number, body: EmailingResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Emailing/{mafId}";
        if (mafId === undefined || mafId === null)
            throw new Error("The parameter 'mafId' must be defined.");
        url_ = url_.replace("{mafId}", encodeURIComponent("" + mafId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailing(_response);
        });
    }

    protected processEmailing(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processCount4(body: Xp360Req | undefined, signal?: AbortSignal | undefined): Promise<Xp360Resp> {
        let url_ = this.baseUrl + "/api/Expert360/ProcessCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessCount4(_response);
        });
    }

    protected processProcessCount4(response: AxiosResponse): Promise<Xp360Resp> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Xp360Resp>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Xp360Resp>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordCount4(body: Xp360Resp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Expert360/RecordCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordCount4(_response);
        });
    }

    protected processRecordCount4(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    expert360(mafId: number, body: Xp360Resp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/Expert360/{mafId}";
        if (mafId === undefined || mafId === null)
            throw new Error("The parameter 'mafId' must be defined.");
        url_ = url_.replace("{mafId}", encodeURIComponent("" + mafId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExpert360(_response);
        });
    }

    protected processExpert360(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param mafId (optional) 
     * @return Success
     */
    getDataByMafId(mafId: number | undefined, signal?: AbortSignal | undefined): Promise<ExportCounts[]> {
        let url_ = this.baseUrl + "/api/Export/GetDataByMafId?";
        if (mafId === null)
            throw new Error("The parameter 'mafId' cannot be null.");
        else if (mafId !== undefined)
            url_ += "mafId=" + encodeURIComponent("" + mafId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataByMafId(_response);
        });
    }

    protected processGetDataByMafId(response: AxiosResponse): Promise<ExportCounts[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExportCounts[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportCounts[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authentication(body: RequestLogin | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Login/Authentication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthentication(_response);
        });
    }

    protected processAuthentication(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processCount5(body: MasterDisplayReq | undefined, signal?: AbortSignal | undefined): Promise<MasterDisplayResp> {
        let url_ = this.baseUrl + "/api/MasterDisplay/ProcessCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessCount5(_response);
        });
    }

    protected processProcessCount5(response: AxiosResponse): Promise<MasterDisplayResp> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MasterDisplayResp>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDisplayResp>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordCount5(body: MasterDisplayResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/MasterDisplay/RecordCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordCount5(_response);
        });
    }

    protected processRecordCount5(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    masterDisplay(mafId: number, body: MasterDisplayResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/MasterDisplay/{mafId}";
        if (mafId === undefined || mafId === null)
            throw new Error("The parameter 'mafId' must be defined.");
        url_ = url_.replace("{mafId}", encodeURIComponent("" + mafId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMasterDisplay(_response);
        });
    }

    protected processMasterDisplay(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OrderModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    places(name: string | undefined, signal?: AbortSignal | undefined): Promise<PlaceBo[]> {
        let url_ = this.baseUrl + "/api/Places?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlaces(_response);
        });
    }

    protected processPlaces(response: AxiosResponse): Promise<PlaceBo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PlaceBo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlaceBo[]>(null as any);
    }

    /**
     * @param clientIdOrName (optional) 
     * @return Success
     */
    getClients(clientIdOrName: string | undefined, signal?: AbortSignal | undefined): Promise<NewBuildAgency[]> {
        let url_ = this.baseUrl + "/api/Signifi/NewBuild/GetClients?";
        if (clientIdOrName === null)
            throw new Error("The parameter 'clientIdOrName' cannot be null.");
        else if (clientIdOrName !== undefined)
            url_ += "clientIdOrName=" + encodeURIComponent("" + clientIdOrName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClients(_response);
        });
    }

    protected processGetClients(response: AxiosResponse): Promise<NewBuildAgency[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NewBuildAgency[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewBuildAgency[]>(null as any);
    }

    /**
     * @param rcClient (optional) 
     * @param contractId (optional) 
     * @return Success
     */
    getAdsByClient(rcClient: string | undefined, contractId: number | undefined, signal?: AbortSignal | undefined): Promise<Programme[]> {
        let url_ = this.baseUrl + "/api/Signifi/NewBuild/GetAdsByClient?";
        if (rcClient === null)
            throw new Error("The parameter 'rcClient' cannot be null.");
        else if (rcClient !== undefined)
            url_ += "rcClient=" + encodeURIComponent("" + rcClient) + "&";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdsByClient(_response);
        });
    }

    protected processGetAdsByClient(response: AxiosResponse): Promise<Programme[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Programme[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Programme[]>(null as any);
    }

    /**
     * @return Success
     */
    getMyBoosts(signal?: AbortSignal | undefined): Promise<BoostBoPaginated> {
        let url_ = this.baseUrl + "/api/Signifi/NewBuild/GetMyBoosts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyBoosts(_response);
        });
    }

    protected processGetMyBoosts(response: AxiosResponse): Promise<BoostBoPaginated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BoostBoPaginated>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoostBoPaginated>(null as any);
    }

    /**
     * @return Success
     */
    getAllBoosts(signal?: AbortSignal | undefined): Promise<BoostBoPaginated> {
        let url_ = this.baseUrl + "/api/Signifi/NewBuild/GetAllBoosts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBoosts(_response);
        });
    }

    protected processGetAllBoosts(response: AxiosResponse): Promise<BoostBoPaginated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BoostBoPaginated>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoostBoPaginated>(null as any);
    }

    /**
     * @param page (optional) 
     * @param itemsPerPage (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @return Success
     */
    getAllFilterBoosts(page: number | undefined, itemsPerPage: number | undefined, order: string | undefined, orderDirection: string | undefined, signal?: AbortSignal | undefined): Promise<BoostBoPaginated> {
        let url_ = this.baseUrl + "/api/Signifi/NewBuild/GetAllFilterBoosts?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (itemsPerPage === null)
            throw new Error("The parameter 'itemsPerPage' cannot be null.");
        else if (itemsPerPage !== undefined)
            url_ += "itemsPerPage=" + encodeURIComponent("" + itemsPerPage) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllFilterBoosts(_response);
        });
    }

    protected processGetAllFilterBoosts(response: AxiosResponse): Promise<BoostBoPaginated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BoostBoPaginated>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoostBoPaginated>(null as any);
    }

    /**
     * @param page (optional) 
     * @param itemsPerPage (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @return Success
     */
    getMyFilterBoosts(page: number | undefined, itemsPerPage: number | undefined, order: string | undefined, orderDirection: string | undefined, signal?: AbortSignal | undefined): Promise<BoostBoPaginated> {
        let url_ = this.baseUrl + "/api/Signifi/NewBuild/GetMyFilterBoosts?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (itemsPerPage === null)
            throw new Error("The parameter 'itemsPerPage' cannot be null.");
        else if (itemsPerPage !== undefined)
            url_ += "itemsPerPage=" + encodeURIComponent("" + itemsPerPage) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyFilterBoosts(_response);
        });
    }

    protected processGetMyFilterBoosts(response: AxiosResponse): Promise<BoostBoPaginated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BoostBoPaginated>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoostBoPaginated>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordBoost(body: NewBuildRequest | undefined, signal?: AbortSignal | undefined): Promise<BoostBo> {
        let url_ = this.baseUrl + "/api/Signifi/RecordBoost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordBoost(_response);
        });
    }

    protected processRecordBoost(response: AxiosResponse): Promise<BoostBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BoostBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoostBo>(null as any);
    }

    /**
     * @return Success
     */
    me(signal?: AbortSignal | undefined): Promise<UserBo> {
        let url_ = this.baseUrl + "/api/Users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<UserBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: UserRecord | undefined, signal?: AbortSignal | undefined): Promise<UserBo> {
        let url_ = this.baseUrl + "/api/Users/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateUser(_response);
        });
    }

    protected processCreateOrUpdateUser(response: AxiosResponse): Promise<UserBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBo>(null as any);
    }

    /**
     * @param mail (optional) 
     * @return Success
     */
    getByMail(mail: string | undefined, signal?: AbortSignal | undefined): Promise<UserBo> {
        let url_ = this.baseUrl + "/api/Users/GetByMail?";
        if (mail === null)
            throw new Error("The parameter 'mail' cannot be null.");
        else if (mail !== undefined)
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByMail(_response);
        });
    }

    protected processGetByMail(response: AxiosResponse): Promise<UserBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBo>(null as any);
    }

    /**
     * @return Success
     */
    users(signal?: AbortSignal | undefined): Promise<UserBo[]> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers(_response);
        });
    }

    protected processUsers(response: AxiosResponse): Promise<UserBo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserBo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBo[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param itemsPerPage (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param searchUser (optional) 
     * @return Success
     */
    getAllUsers(page: number | undefined, itemsPerPage: number | undefined, order: string | undefined, orderDirection: string | undefined, searchUser: string | undefined, signal?: AbortSignal | undefined): Promise<UserBoPaginated> {
        let url_ = this.baseUrl + "/api/Users/GetAllUsers?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (itemsPerPage === null)
            throw new Error("The parameter 'itemsPerPage' cannot be null.");
        else if (itemsPerPage !== undefined)
            url_ += "itemsPerPage=" + encodeURIComponent("" + itemsPerPage) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (searchUser === null)
            throw new Error("The parameter 'searchUser' cannot be null.");
        else if (searchUser !== undefined)
            url_ += "searchUser=" + encodeURIComponent("" + searchUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: AxiosResponse): Promise<UserBoPaginated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return throwException("Success", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserBoPaginated>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBoPaginated>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processCount6(body: VedettePlusReq | undefined, signal?: AbortSignal | undefined): Promise<DisplayResp> {
        let url_ = this.baseUrl + "/api/VedettePlus/ProcessCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessCount6(_response);
        });
    }

    protected processProcessCount6(response: AxiosResponse): Promise<DisplayResp> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DisplayResp>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisplayResp>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordCount6(body: VedettePlusResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/VedettePlus/RecordCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordCount6(_response);
        });
    }

    protected processRecordCount6(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    vedettePlus(mafId: number, body: VedettePlusResp | undefined, signal?: AbortSignal | undefined): Promise<CountBo> {
        let url_ = this.baseUrl + "/api/VedettePlus/{mafId}";
        if (mafId === undefined || mafId === null)
            throw new Error("The parameter 'mafId' must be defined.");
        url_ = url_.replace("{mafId}", encodeURIComponent("" + mafId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVedettePlus(_response);
        });
    }

    protected processVedettePlus(response: AxiosResponse): Promise<CountBo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountBo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountBo>(null as any);
    }

    /**
     * @return Success
     */
    getVersion(signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Version/GetVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface AdjustableOffer {
    minAvailable?: number;
    minPrice?: number;
    maxAvailable?: number;
    maxPrice?: number;
    shareOfVoice?: number;
    cpmAvg?: number;
}

export enum BaseComptage {
    Alerte = "Alerte",
    Optin = "Optin",
}

export interface BoostBo {
    id?: string;
    clientId?: string | undefined;
    clientName?: string | undefined;
    createdDate?: Date;
    userId: string;
    programmes: Programme[];
    bsiId: number;
    nbMaxBoost: number;
    downSellDate?: string | undefined;
    isActiveContract?: boolean;
    contractId: number;
    contractType?: ContractType;
    isUpcomingContract?: boolean;
    readonly programmeCount?: number;
}

export interface BoostBoPaginated {
    boostBo?: BoostBo[] | undefined;
    page?: number;
    itemsPerPage?: number;
    total?: number;
}

export enum BoostStatus {
    Default = "Default",
    Boost_Recurrent = "Boost_Recurrent",
    Boost_NonRecurrent = "Boost_NonRecurrent",
    Boost_Deleted = "Boost_Deleted",
    Pending_NewClient = "Pending_NewClient",
    Pending_ExistingClient = "Pending_ExistingClient",
    Pending_Deleted = "Pending_Deleted",
    Error = "Error",
    Boost_InProgess_Signifi = "Boost_InProgess_Signifi",
}

export enum BroadcastMedium {
    SELOGER = "SELOGER",
    LOGICIMMO = "LOGICIMMO",
    SELOGERNEUF = "SELOGERNEUF",
    LOGICIMMONEUF = "LOGICIMMONEUF",
    BELLESDEMEURES = "BELLESDEMEURES",
    LUXRESIDENCE = "LUXRESIDENCE",
}

export interface Classified {
    rcClient?: string | undefined;
    parentAnnonce?: number | undefined;
    idAnnonce?: number;
    agencyId?: number | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    area?: number | undefined;
    city?: string | undefined;
    title?: string | undefined;
    price?: number | undefined;
    description?: string | undefined;
    agencyLogo?: string | undefined;
    brandName?: string | undefined;
    propertyType?: string | undefined;
    nbRoom?: number | undefined;
    nbPiece?: number | undefined;
    images?: string | undefined;
    libelle?: string | undefined;
}

export interface ClientBo {
    id?: string;
    clientId: string;
    clientName: string;
    intensity: ClientIntensity[];
    catchmentZone?: PlaceBo[] | undefined;
    legacyId?: number;
}

export interface ClientIntensity {
    level: number;
    available: boolean;
    prints?: number | undefined;
    impressions: number;
    budget: number;
    shareOfVoice?: number | undefined;
}

export interface Contract {
    id?: number;
    nbBoost?: number;
    downSellDate?: Date;
    type?: number;
}

export enum ContractType {
    Bronze = "Bronze",
    Silver = "Silver",
}

export interface CountBo {
    id?: string;
    mafProduct: MAFProduct;
    productName?: string | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    createdDate?: Date;
    userID: string;
    market: Market;
    status: string;
    countData: IAmCountable;
    totalBudget: number;
    locality: PlaceBo[];
    mafId: number;
    totalImpPurchased?: number;
}

export interface CountBoPaginated {
    page?: number;
    itemsPerPage?: number;
    total?: number;
    countBo?: CountBo[] | undefined;
}

export interface CountFilters {
    productName?: MAFProduct;
}

export interface DetailByPostalCode {
    code?: string | undefined;
    name?: string | undefined;
    available?: number;
    sold?: number;
    total?: number;
    segmentByPostalCode?: SegmentByPostalCode;
    isInsufficientShareOfVoice?: boolean;
    impressionProposedForIntensity1?: number;
    impressionProposedForIntensity2?: number;
    impressionProposedForIntensity3?: number;
}

export interface DisplayReq {
    market?: Market;
    targetings?: DisplayTargetings[] | undefined;
    postalCodes?: string[] | undefined;
    projectTypes: string[];
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    periodicity: string;
    isAllFrance?: boolean | undefined;
    radius?: number;
}

export interface DisplayResp {
    cpm?: { [key: string]: number; } | undefined;
    displayReq?: DisplayReq;
    forecasts?: ForecastResult[] | undefined;
    mafProduct?: MAFProduct;
    totalBudget?: number;
    totalImpPurchased?: number;
    locality?: PlaceBo[] | undefined;
    countName?: string | undefined;
    forescastResultSplitByPosition?: { [key: string]: ForecastResult[]; } | undefined;
    forecastSplitByPosition?: ForecastResult[] | undefined;
    saveBy?: string | undefined;
    localityNameByZipCode?: { [key: string]: string[]; } | undefined;
}

export interface DisplayTargetings {
    distributionType: string;
    broadcastMediums: string[];
}

export enum DistributionType {
    Sellers = "Sellers",
    SellersNew = "SellersNew",
    InvestmentProduct = "InvestmentProduct",
    Tenants = "Tenants",
    PrestigeSellers = "PrestigeSellers",
    ConstructionProjects = "ConstructionProjects",
    Land = "Land",
}

export interface EmailingReq {
    baseComptage: BaseComptage;
    targetings: Targetings[];
    locationZipCode: string[];
    productTypes: ProductType[];
    price?: PriceFilter;
    numberOfPieces?: RangeFilter;
    dateSent: Date;
    market?: Market;
    radius?: number;
}

export interface EmailingResp {
    mafProduct?: MAFProduct;
    emailingNeufReq?: EmailingReq;
    localityNameByZipCode?: { [key: string]: string[]; } | undefined;
    localityNameByPlaceId?: { [key: string]: string[]; } | undefined;
    bySiteGroup?: { [key: string]: RespBySiteGroup; } | undefined;
    productionFee?: number;
    allEmailsAvailable?: number;
    countName?: string | undefined;
}

export interface EmaillingSelectableValues {
    baseComptage?: { [key: string]: string; } | undefined;
    targetings?: { [key: string]: TargetingsValues; } | undefined;
    productType?: { [key: string]: string; } | undefined;
    filters?: { [key: string]: FiltersValues; } | undefined;
    targetRestrictionsByMarket?: { [key: string]: MarketRestrictions; } | undefined;
}

export interface ExportCounts {
    mafId?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    projectTypes?: string | undefined;
    locality?: string | undefined;
    brandContent?: string | undefined;
    totalImpPurchased?: number;
    totalBudget?: number;
    externalURL?: string | undefined;
    productName?: string | undefined;
    sites?: string | undefined;
    sendDate?: Date | undefined;
    format?: string | undefined;
    criteria?: string | undefined;
    type?: string | undefined;
}

export enum ExportFilter {
    NeufConstruire = "NeufConstruire",
    Expert360 = "Expert360",
    LuxeBucom = "LuxeBucom",
}

export interface FiltersValues {
    min?: number;
    max?: number;
}

export interface ForecastResult {
    code?: string | undefined;
    name?: string | undefined;
    available?: number;
    sold?: number;
    total?: number;
    purchased?: number;
    budget?: number;
}

export interface IAmCountable {
    mafProduct?: MAFProduct;
    readonly countName?: string | undefined;
}

export enum MAFProduct {
    EmailingAlerte = "EmailingAlerte",
    EmailingOptin = "EmailingOptin",
    MasterDisplay = "MasterDisplay",
    Expert360 = "Expert360",
    GrandAngle = "GrandAngle",
    NatifInterAnnonces = "NatifInterAnnonces",
    Pave = "Pave",
    MasterDisplayNeuf = "MasterDisplayNeuf",
    Sellers = "Sellers",
    SellersNew = "SellersNew",
    HouseModels = "HouseModels",
    ConstructionProjects = "ConstructionProjects",
    DisplayConstruire = "DisplayConstruire",
    DisplayBureauxCommerce = "DisplayBureauxCommerce",
    VedettePlus = "VedettePlus",
    LandWithHouses = "LandWithHouses",
    Lands = "Lands",
    SellersMastheadLOGICIMMO = "SellersMastheadLOGICIMMO",
    SellersMastheadSELOGER = "SellersMastheadSELOGER",
    SellersPaveLOGICIMMO = "SellersPaveLOGICIMMO",
    SellersPaveSELOGER = "SellersPaveSELOGER",
    SellersGrandAngleLOGICIMMO = "SellersGrandAngleLOGICIMMO",
    SellersGrandAngleSELOGER = "SellersGrandAngleSELOGER",
    SellersNatifLOGICIMMO = "SellersNatifLOGICIMMO",
    SellersNatifSELOGER = "SellersNatifSELOGER",
    SellersNewMastheadLOGICIMMONEUF = "SellersNewMastheadLOGICIMMONEUF",
    SellersNewMastheadSELOGERNEUF = "SellersNewMastheadSELOGERNEUF",
    SellersNewPaveLOGICIMMONEUF = "SellersNewPaveLOGICIMMONEUF",
    SellersNewPaveSELOGERNEUF = "SellersNewPaveSELOGERNEUF",
    SellersNewNatifLOGICIMMONEUF = "SellersNewNatifLOGICIMMONEUF",
    SellersNewNatifSELOGERNEUF = "SellersNewNatifSELOGERNEUF",
    HouseModelsMastheadSELOGERCONSTRUIRE = "HouseModelsMastheadSELOGERCONSTRUIRE",
    HouseModelsPaveSELOGERCONSTRUIRE = "HouseModelsPaveSELOGERCONSTRUIRE",
    HouseModelsNatifSELOGERCONSTRUIRE = "HouseModelsNatifSELOGERCONSTRUIRE",
    ConstructionProjectsMastheadSELOGERCONSTRUIRE = "ConstructionProjectsMastheadSELOGERCONSTRUIRE",
    ConstructionProjectsPaveSELOGERCONSTRUIRE = "ConstructionProjectsPaveSELOGERCONSTRUIRE",
    ConstructionProjectsNatifSELOGERCONSTRUIRE = "ConstructionProjectsNatifSELOGERCONSTRUIRE",
    LandWithHousesMastheadSELOGERCONSTRUIRE = "LandWithHousesMastheadSELOGERCONSTRUIRE",
    LandWithHousesPaveSELOGERCONSTRUIRE = "LandWithHousesPaveSELOGERCONSTRUIRE",
    LandWithHousesNatifSELOGERCONSTRUIRE = "LandWithHousesNatifSELOGERCONSTRUIRE",
    LandsMastheadSELOGERCONSTRUIRE = "LandsMastheadSELOGERCONSTRUIRE",
    LandsPaveSELOGERCONSTRUIRE = "LandsPaveSELOGERCONSTRUIRE",
    LandsNatifSELOGERCONSTRUIRE = "LandsNatifSELOGERCONSTRUIRE",
    DisplayLuxury = "DisplayLuxury",
    DisplayPerformance = "DisplayPerformance",
    DisplayLuxuryBellesDemeuresMasthead = "DisplayLuxuryBellesDemeuresMasthead",
    DisplayLuxuryBellesDemeuresNatif = "DisplayLuxuryBellesDemeuresNatif",
    DisplayLuxuryBellesDemeuresBillboard = "DisplayLuxuryBellesDemeuresBillboard",
    DisplayLuxuryLuxResidenceMasthead = "DisplayLuxuryLuxResidenceMasthead",
    DisplayLuxuryLuxResidenceNatif = "DisplayLuxuryLuxResidenceNatif",
    EmailingAlerteConstruire = "EmailingAlerteConstruire",
    EmailingOptinConstruire = "EmailingOptinConstruire",
    DisplayBuComMasthead = "DisplayBuComMasthead",
    DisplayBuComMastheadPlus = "DisplayBuComMastheadPlus",
    DisplayBuComNatif = "DisplayBuComNatif",
    DisplayBuComGrandAngle = "DisplayBuComGrandAngle",
    SellersNewDisplayPerformanceLOGICIMMONEUFPave = "SellersNewDisplayPerformanceLOGICIMMONEUFPave",
    SellersNewDisplayPerformanceSELOGERNEUFPave = "SellersNewDisplayPerformanceSELOGERNEUFPave",
    SellersNewDisplayPerformanceLOGICIMMONEUFMasthead = "SellersNewDisplayPerformanceLOGICIMMONEUFMasthead",
    SellersNewDisplayPerformanceSELOGERNEUFMasthead = "SellersNewDisplayPerformanceSELOGERNEUFMasthead",
    SellersDisplayPerformanceSELOGERPave = "SellersDisplayPerformanceSELOGERPave",
    SellersDisplayPerformanceLOGICIMMOPave = "SellersDisplayPerformanceLOGICIMMOPave",
    SellersDisplayPerformanceSELOGERMasthead = "SellersDisplayPerformanceSELOGERMasthead",
    SellersDisplayPerformanceLOGICIMMOMasthead = "SellersDisplayPerformanceLOGICIMMOMasthead",
}

export enum Market {
    Neuf = "Neuf",
    Ancien = "Ancien",
    Construire = "Construire",
    Luxe = "Luxe",
    BureauxEtCommerce = "BureauxEtCommerce",
}

export interface MarketRestrictions {
    restrictedBroadcastMediums?: string[] | undefined;
    excludedTargetings?: string[] | undefined;
}

export interface MasterDisplayNeufSelectableValues {
    masterDisplayNeufSelectableValues?: MasterDisplayNeufSelectableValues;
    targetings?: { [key: string]: MDNTargetingsValues; } | undefined;
}

export interface MasterDisplayReq {
    market?: Market;
    postalCodes: string[];
    broadcastMediums: string[];
    projectTypes: string[];
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    periodicity: string;
    radius?: number;
}

export interface MasterDisplayResp {
    masterDisplayReq?: MasterDisplayReq;
    forecasts?: ForecastResult[] | undefined;
    mafProduct?: MAFProduct;
    totalBudget?: number;
    totalImpPurchased?: number;
    locality?: PlaceBo[] | undefined;
    countName?: string | undefined;
}

export interface MDNTargetingsValues {
    label?: string | undefined;
    order?: number;
    broadcastMediums?: string[] | undefined;
}

export interface NewBuildAgency {
    clientId?: string | undefined;
    clientName?: string | undefined;
    nbMaxBoost?: number;
    contractId?: number;
    devisNum?: number | undefined;
}

export interface NewBuildRequest {
    programmes?: Programme[] | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    nbMaxBoost?: number;
    bsiId?: number;
    downSellDate?: string | undefined;
    contractId?: number;
    contractType?: ContractType;
}

export interface OrderModel {
    maf?: string | undefined;
    advertiser?: string | undefined;
    traffiker?: string | undefined;
    market?: string | undefined;
    marketEnum?: Market;
    wording?: string | undefined;
    endDate?: Date | undefined;
    format?: string | undefined;
    element?: string | undefined;
    clients?: string | undefined;
    site?: string | undefined;
    localities?: string | undefined;
    mafVolume?: number;
    startDate?: Date | undefined;
    postalCodes?: string[] | undefined;
    sites?: string[] | undefined;
    formats?: string[] | undefined;
    product?: string | undefined;
    projectType?: string[] | undefined;
    distributionType?: string | undefined;
    title?: string | undefined;
}

export interface PerformanceDisplayResp {
    mafProduct?: MAFProduct;
    countName?: string | undefined;
    displayReq?: DisplayReq;
    forecasts?: PerformanceForecastResult[] | undefined;
    totalBudget?: number;
    totalImpPurchased?: number;
    locality?: PlaceBo[] | undefined;
    forescastResultSplitByPosition?: { [key: string]: PerformanceForecastResult[]; } | undefined;
    forecastSplitByPosition?: PerformanceForecastResult[] | undefined;
    cpm?: { [key: string]: number; } | undefined;
    saveBy?: string | undefined;
    localityNameByZipCode?: { [key: string]: string[]; } | undefined;
}

export interface PerformanceForecastResult {
    click?: number;
    code?: string | undefined;
    name?: string | undefined;
    available?: number;
    sold?: number;
    total?: number;
    purchased?: number;
    budget?: number;
}

export interface PlaceBo {
    id: string;
    code: string;
    name: string;
    nameLight?: string | undefined;
    idManager?: string | undefined;
    placeType?: PlaceType;
}

export enum PlaceType {
    Department = "Department",
    City = "City",
}

export interface PriceFilter {
    min: number;
    max: number;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export enum ProductType {
    Apartment = "Apartment",
    House = "House",
    Loft = "Loft",
    HouseModel = "HouseModel",
    Plot = "Plot",
}

export interface Programme {
    idProgramme?: string | undefined;
    projet?: string | undefined;
    city?: string | undefined;
    codePostal?: string | undefined;
    url?: string | undefined;
    idAnnonce?: number;
    images?: string | undefined;
    brandName?: string | undefined;
    parentAnnonce?: number | undefined;
    publicationDateTime?: Date;
    status?: BoostStatus;
    isChecked?: boolean;
    toKeep?: boolean | undefined;
}

export interface RangeFilter {
    min: number;
    max: number;
}

export interface RequestLogin {
    login?: string | undefined;
    password?: string | undefined;
}

export interface RespBySiteGroup {
    siteGroup?: SiteGroup;
    emailsAvailable?: number;
    requestedBroadcastMediums?: BroadcastMedium[] | undefined;
    respondedBroadcastMediums?: BroadcastMedium[] | undefined;
    budgetMin?: number;
    budgetMax?: number;
    selectedBudget?: number;
    selectedEmails?: number;
}

export enum Role {
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_USER = "ROLE_USER",
}

export interface SegmentByPostalCode {
    id?: string;
    postalCode?: string | undefined;
    segment?: string | undefined;
    intensity1?: number;
    intensity2?: number;
    intensity3?: number;
    cpm?: number;
}

export enum SiteGroup {
    SeLoger = "SeLoger",
    LogicImmo = "LogicImmo",
}

export interface Targetings {
    distributionType: DistributionType;
    broadcastMediums: BroadcastMedium[];
}

export interface TargetingsValues {
    label?: string | undefined;
    order?: number;
    broadcastMediums?: string[] | undefined;
    restrictedBroadcastMediums?: string[] | undefined;
}

export enum TypeProfil {
    Commerce = "Commerce",
    Studio = "Studio",
    AdfactoryOperations = "AdfactoryOperations",
    Others = "Others",
}

export interface UserBo {
    id?: string;
    legacyId?: number | undefined;
    email?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    typeProfil?: TypeProfil;
    markets?: Market[] | undefined;
    roles?: Role[] | undefined;
}

export interface UserBoPaginated {
    page?: number;
    itemsPerPage?: number;
    total?: number;
    userBo?: UserBo[] | undefined;
}

export interface UserRecord {
    email?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    typeProfil?: TypeProfil;
    markets?: Market[] | undefined;
    roles?: Role[] | undefined;
}

export interface VedettePlusReq {
    market?: Market;
    targetings?: DisplayTargetings[] | undefined;
    postalCodes?: string[] | undefined;
    projectTypes: string[];
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    periodicity: string;
    isAllFrance?: boolean | undefined;
    radius?: number;
}

export interface VedettePlusResp {
    vedettePlusReq?: VedettePlusReq;
    forecasts?: ForecastResult[] | undefined;
    mafProduct?: MAFProduct;
    totalBudget?: number;
    locality?: PlaceBo[] | undefined;
    countName?: string | undefined;
    excludePostalCode?: any[] | undefined;
    localityNameByZipCode?: { [key: string]: string[]; } | undefined;
}

export interface Xp360Req {
    clientId: string;
    market?: Market;
    postalCodes: string[];
    broadcastMediums: string[];
    projectTypes: string[];
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    periodicity: string;
    radius?: number;
}

export interface Xp360Resp {
    xp360Req?: Xp360Req;
    mafProduct?: MAFProduct;
    client?: ClientBo;
    intensity?: number;
    print?: number | undefined;
    displayBudget?: number;
    retargetingBudget?: number;
    totalBudget?: number;
    totalImpPurchased?: number;
    locality?: PlaceBo[] | undefined;
    forescastResultSplitByPosition?: { [key: string]: ForecastResult[]; } | undefined;
    forescastResultSplitByPostalCodes?: { [key: string]: DetailByPostalCode; } | undefined;
    totalAvailableForecast?: number;
    totalSoldForecast?: number;
    totalForecast?: number;
    insufficientShareOfVoice?: string[] | undefined;
    externalURL?: boolean | undefined;
    countName?: string | undefined;
    brandContentCommentary?: string | undefined;
    adjustableOffer?: AdjustableOffer;
    brandContentAdjustableOffer?: boolean | undefined;
    localityNameByZipCode?: { [key: string]: string[]; } | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

/* eslint disable */

const authClient: OktaAuth = new OktaAuth(oktaAuthConfig)

const getToken = async () => {
  const tokenManager: TokenManagerInterface = await authClient.tokenManager
  const idToken: IDToken = await tokenManager.get('idToken') as IDToken
  return idToken.idToken
}